import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { EMPTY_OVERVIEW, type TelemetryOverview } from '@/lib/writer/telemetryTypes';

export const RANGES = [
  { label: '24h', days: 1 },
  { label: '7d', days: 7 },
  { label: '30d', days: 30 },
  { label: '90d', days: 90 },
];

export function useWriterTelemetry(days: number) {
  const [data, setData] = useState<TelemetryOverview | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const to = new Date();
  const from = new Date(to.getTime() - days * 24 * 60 * 60 * 1000);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    const toDate = new Date();
    const fromDate = new Date(toDate.getTime() - days * 24 * 60 * 60 * 1000);
    const { data: payload, error: err } = await supabase.rpc(
      'writer_telemetry_overview' as never,
      { p_from: fromDate.toISOString(), p_to: toDate.toISOString() } as never,
    );
    if (err) {
      setError(err.message);
      setData(null);
    } else {
      setData({ ...EMPTY_OVERVIEW, ...((payload ?? {}) as Partial<TelemetryOverview>) });
    }
    setLoading(false);
  }, [days]);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, error, loading, reload: load, from, to };
}
